import React from 'react';
import { useTranslation } from 'react-i18next';
import { Colors } from '../../themes';
import { MultiItemSelector } from '../forms/multiItemSelector';

type Category = {
  id: string;
  name: string;
};

type CategorySelectorProps = {
  selectedCategories: Category[];
  availableCategories: Category[];
  onCategoriesChange: (categories: Category[]) => void;
  onCreateCategory?: (name: string) => Promise<Category>;
  disabled?: boolean;
  useCropCircle?: boolean;
  onSelectorEdit?: () => void;
};

export const CategorySelector: React.FC<CategorySelectorProps> = ({
  selectedCategories,
  availableCategories,
  onCategoriesChange,
  onCreateCategory,
  disabled = false,
  useCropCircle,
  onSelectorEdit,
}) => {
  const { t } = useTranslation();

  return (
    <MultiItemSelector
      selectedItems={selectedCategories}
      availableItems={availableCategories}
      onItemsChange={onCategoriesChange}
      onCreateItem={onCreateCategory}
      disabled={disabled}
      title={t('file.create.category')}
      placeholder={t('file.create.selectCategory')}
      searchPlaceholder={t('file.create.searchCategory')}
      createButtonText={t('file.create.createCategory')}
      containerBackgroundColor={
        useCropCircle ? Colors.brand.white : Colors.white
      }
      itemType="category"
      emptyText={t('file.create.emptyStateMessage')}
      useCropCircle={useCropCircle}
      onSelectorEdit={onSelectorEdit}
    />
  );
};
